import React from "react";
import {
  ROUTES,
  STATUS_EC,
  STATUS_VA,
  MIA_AGENDAMENTO_EC
} from "utils/constants";
import * as CONST_MAP from "utils/constants";
import { meuApeUrls } from "@company-mrv/mrv-design-system/components";
import { Anexo, Book, AnexoSensia, BookSensia } from "assets/svg";
import {
  formatDate,
  STATUS,
  isTodayVA,
  formatDateParseZone
} from "../functions";
import { getThemePropertyValue } from "../pluginHelpers";

export const MILESTONE_STATUS = {
  COMING_SOON: 1,
  RELEASED: 2,
  COMPLETE: 3
};

export const MILESTONES_LOADING_STATUS = {
  LOADING: 1,
  LOADED: 2,
  ERROR: 3
};

export const MILESTONE_STATUS_DATA = {
  [MILESTONE_STATUS.COMING_SOON]: {
    text: "Em breve",
    color: "default"
  },
  [MILESTONE_STATUS.RELEASED]: {
    text: "Liberado",
    color: "orange"
  },
  [MILESTONE_STATUS.COMPLETE]: {
    text: "Concluído",
    color: "primary"
  }
};

export const MILESTONES = {
  VISITA: 0,
  VISTORIA: 1,
  ENTREGA: 2
};

export const MILESTONES_SECTIONS = {
  VISIT: "visita",
  INSPECTION: "vistoria",
  KEYS_DELIVERY: "entrega-de-chaves"
};

export const MILESTONES_ROUTES = [
  `${ROUTES.MILESTONES}/${MILESTONES_SECTIONS.VISIT}`,
  `${ROUTES.MILESTONES}/${MILESTONES_SECTIONS.INSPECTION}`,
  `${ROUTES.MILESTONES}/${MILESTONES_SECTIONS.KEYS_DELIVERY}`
];

const hasInadimplencia = perfil => {
  return (
    perfil.statusFinanceiro === STATUS.LIGHT_DEBT ||
    perfil.statusFinanceiro === STATUS.CRITICAL_DEBT ||
    perfil.statusFinanceiro === STATUS.NEGOTIATED
  );
};

export const MILESTONES_DATA = [
  {
    id: 1,
    title: getThemePropertyValue(
      "milestones.texts.VISITA_A_OBRA.title.text",
      "Visita à obra"
    ),
    titleGtm: "Visita a obra",
    text: milestone => {
      if (milestone) {
        if (milestone.status === MILESTONE_STATUS.RELEASED) {
          const visitDate = milestone?.details?.date;
          const formatDate1 = formatDateParseZone(visitDate, "DD/MM/YY");
          const hasMinutes = formatDateParseZone(visitDate, "mm") !== "00";
          const formatDate2 = formatDateParseZone(
            visitDate,
            hasMinutes ? "H[h]mm" : "H[h]"
          );

          return (
            <>
              A visita está marcada para{" "}
              <b>
                {formatDate1}, às {formatDate2}.
              </b>{" "}
              Prepare-se para essa etapa!
            </>
          );
        }
        if (milestone.status === MILESTONE_STATUS.COMPLETE) {
          return getThemePropertyValue(
            "milestones.texts.VISITA_A_OBRA.complete.text",
            <>
              <b>Está etapa foi concluida.</b> Em breve, vamos te convidar para
              realizar a vistoria.
            </>
          );
        }
      }
      return getThemePropertyValue(
        "milestones.texts.VISITA_A_OBRA.default.text",
        "Será liberada gradativamente quando a área comum atingir 70% de conclusão."
      );
    },
    link: milestone => {
      if (milestone && milestone.status === MILESTONE_STATUS.COMPLETE) {
        const isActive = getThemePropertyValue(
          "milestones.texts.VISTORIA_DO_IMOVEL.button.complete.link.active",
          undefined
        );
        if (isActive === false) {
          return null;
        }
        return ROUTES.TRACK_WORK;
      }
      return MILESTONES_ROUTES[MILESTONES.VISITA];
    },
    linkText: milestone => {
      if (milestone) {
        if (milestone.status === MILESTONE_STATUS.RELEASED) {
          return "Me preparar para a visita";
        }
        if (milestone.status === MILESTONE_STATUS.COMPLETE) {
          return "Acompanhar evolução da obra";
        }
      }
      return "Saber mais sobre a visita";
    },
    statusText: milestone => {
      if (milestone && milestone.status === MILESTONE_STATUS.RELEASED) {
        return "Agendado";
      }
      return MILESTONE_STATUS_DATA[milestone.status].text;
    }
  },
  {
    id: 2,
    title: getThemePropertyValue(
      "milestones.texts.VISTORIA_DO_IMOVEL.title.text",
      "Vistoria do imóvel"
    ),
    titleGtm: "Vistoria do imóvel",
    statusTextGtm: milestone => {
      if (milestone && milestone.status === MILESTONE_STATUS.RELEASED) {
        if (milestone?.details?.reason === STATUS_VA.VA_WAP_CONTATO) {
          return "Aguardando Agendamento - Revistoria Não Digital";
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_EMPREENDIMENTO_LIBERADO
        ) {
          return "Bloco liberado";
        }
        if (
          milestone?.details?.reason ===
          STATUS_VA.VA_AGUARDADO_AGENDAMENTO_REVISTORIA
        ) {
          return "Aguardando Agendamento - Revistoria";
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_AGENDAMENTO
        ) {
          return "Aguardando agendamento";
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_VISTORIA) {
          return "Aguardando vistoria";
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REVISTORIA) {
          return "Aguardando revistoria";
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REAGENDAMENTO
        ) {
          return "Aguardando reagendamento";
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REPARO) {
          return "Aguardando reparo da unidade";
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_ANALISE_TECNICA
        ) {
          return "Aguardando análise técnica";
        }
        if (milestone?.details?.reason === STATUS_VA.VA_EM_PROCESSAMENTO) {
          return "Em processamento";
        }
      }
      return MILESTONE_STATUS_DATA[milestone.status].text;
    },
    statusText: milestone => {
      if (milestone && milestone.status === MILESTONE_STATUS.RELEASED) {
        if (milestone?.details?.reason === STATUS_VA.VA_WAP_CONTATO) {
          return "Aguardando agendamento";
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_EMPREENDIMENTO_LIBERADO
        ) {
          return "Bloco liberado";
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_AGENDAMENTO ||
          milestone?.details?.reason ===
            STATUS_VA.VA_AGUARDADO_AGENDAMENTO_REVISTORIA
        ) {
          return "Aguardando agendamento";
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_VISTORIA) {
          return "Aguardando vistoria";
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REVISTORIA) {
          return "Aguardando revistoria";
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REAGENDAMENTO
        ) {
          return "Aguardando reagendamento";
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REPARO) {
          return "Aguardando reparo da unidade";
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_ANALISE_TECNICA
        ) {
          return "Aguardando análise técnica";
        }
        if (milestone?.details?.reason === STATUS_VA.VA_EM_PROCESSAMENTO) {
          return "Em processamento";
        }
      }
      return MILESTONE_STATUS_DATA[milestone.status].text;
    },
    text: (milestone, _callback) => {
      if (milestone) {
        if (milestone.status === MILESTONE_STATUS.COMPLETE) {
          return (
            <>
              <b>Vistoria concluída!</b> A próxima etapa da sua jornada é a
              entrega das chaves.
            </>
          );
        }
        if (milestone.status === MILESTONE_STATUS.RELEASED) {
          if (milestone?.details?.reason === STATUS_VA.VA_WAP_CONTATO) {
            return "Entraremos em contato por telefone ou WhatsApp para agendar a data e o horário da nova vistoria.";
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_EMPREENDIMENTO_LIBERADO
          ) {
            return "Estamos finalizando o seu imóvel para a vistoria, aguarde.";
          }
          if (
            milestone?.details?.reason ===
            STATUS_VA.VA_AGUARDADO_AGENDAMENTO_REVISTORIA
          ) {
            return getThemePropertyValue(
              "milestones.texts.VISTORIA_DO_IMOVEL.released_VA_AGUARDADO_AGENDAMENTO_REVISTORIA.text",
              <>
                <b>Agende a revistoria</b> do seu MRV e veja como analisar o
                imóvel com o guia.
              </>
            );
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_AGENDAMENTO
          ) {
            return getThemePropertyValue(
              "milestones.texts.VISTORIA_DO_IMOVEL.released_VA_AGUARDANDO_AGENDAMENTO__VA_REPROVADA_REPARO_REALIZADO.text",
              <>
                <b>Agende a vistoria</b> do seu MRV.
              </>
            );
          }
          if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_VISTORIA) {
            return (
              <>
                <b>
                  Agendado para{" "}
                  {formatDate(milestone?.details?.date, "DD/MM/YY")} às{" "}
                  {formatDate(milestone?.details?.date, "HH:mm")}h.
                </b>{" "}
                Enquanto aguarda a vistoria, veja o nosso guia.
              </>
            );
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REVISTORIA
          ) {
            return (
              <>
                <b>
                  Agendado para{" "}
                  {formatDate(milestone?.details?.date, "DD/MM/YY")} às{" "}
                  {formatDate(milestone?.details?.date, "HH:mm")}h.
                </b>{" "}
                Se prepare para esse momento lendo o nosso guia.
              </>
            );
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REAGENDAMENTO
          ) {
            return getThemePropertyValue(
              "milestones.texts.VISTORIA_DO_IMOVEL.released_VA_AGUARDANDO_REAGENDAMENTO_CLIENTE_NAO_COMPARECEU__VA_AGUARDANDO_REAGENDAMENTO_CLIENTE_SEM_DISPONIBILIDADE__VA_AGUARDANDO_REAGENDAMENTO_SEM_CONTATO.text",
              <>
                <b>Reagende</b> a vistoria do seu MRV.
              </>
            );
          }
          if (
            milestone?.details?.reason ===
            STATUS_VA.VA_AGUARDANDO_ANALISE_TECNICA
          ) {
            return getThemePropertyValue(
              "milestones.texts.VISTORIA_DO_IMOVEL.released_VA_AGUARDANDO_ANALISE_TECNICA.text",
              <>
                <b>Estamos analisando</b> suas considerações. Em breve, vamos
                liberar o agendamento.
              </>
            );
          }
          if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REPARO) {
            return (
              <>
                Os <b>reparos na sua unidade estão em andamento.</b> Em breve,
                vamos liberar o agendamento para a nova vistoria.
              </>
            );
          }
          if (milestone?.details?.reason === STATUS_VA.VA_EM_PROCESSAMENTO) {
            return getThemePropertyValue(
              "milestones.texts.VISTORIA_DO_IMOVEL.released_VA_EM_PROCESSAMENTO.text",
              <>
                Estamos processando a conclusão da sua vistoria. Parabéns por
                ter dado mais um passo rumo ao seu sonho.
              </>
            );
          }
          if (milestone?.details?.reason === null) {
            return getThemePropertyValue(
              "milestones.texts.VISTORIA_DO_IMOVEL.default.text",
              <>
                O seu empreendimento foi liberado! Estamos finalizando o seu MRV
                para a vistoria, aguarde.
              </>
            );
          }
        }
      }
      return getThemePropertyValue(
        "milestones.texts.VISTORIA_DO_IMOVEL.default.text",
        "Nesta etapa, você vai conhecer e vistoriar o seu MRV."
      );
    },
    linkText: milestone => {
      if (milestone) {
        if (
          milestone?.status === MILESTONE_STATUS.COMING_SOON ||
          milestone?.details?.reason === null
        ) {
          const isActive = getThemePropertyValue(
            "milestones.texts.VISTORIA_DO_IMOVEL.button.comingSoon.link.active",
            undefined
          );
          if (isActive === false) {
            return undefined;
          }
          return null;
        }
        if (milestone.status === MILESTONE_STATUS.RELEASED) {
          if (
            milestone?.details?.reason === STATUS_VA.VA_EMPREENDIMENTO_LIBERADO
          ) {
            return null;
          }
          if (
            milestone?.details?.reason ===
            STATUS_VA.VA_AGUARDADO_AGENDAMENTO_REVISTORIA
          ) {
            return "Agendar revistoria";
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_AGENDAMENTO
          ) {
            return "Agendar vistoria";
          }
          if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_VISTORIA) {
            if (isTodayVA(milestone?.details?.date)) {
              return "Iniciar vistoria";
            }
            return null;
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REVISTORIA
          ) {
            if (isTodayVA(milestone?.details?.date)) {
              return "Iniciar revistoria";
            }
            return null;
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REAGENDAMENTO
          ) {
            return "Reagendar";
          }
        }
      }
      return null;
    },
    link: milestone => {
      if (milestone) {
        if (
          milestone.status === MILESTONE_STATUS.COMING_SOON ||
          milestone?.details?.reason === null
        ) {
          const isActive = getThemePropertyValue(
            "milestones.texts.VISTORIA_DO_IMOVEL.button.comingSoon.link.active",
            undefined
          );
          if (isActive === false) {
            return undefined;
          }
          return null;
        }
        if (milestone.status === MILESTONE_STATUS.COMPLETE) {
          return null;
        }
        if (milestone.status === MILESTONE_STATUS.RELEASED) {
          if (milestone?.details?.reason === STATUS_VA.VA_WAP_CONTATO) {
            return null;
          }

          if (
            milestone?.details?.reason === STATUS_VA.VA_EMPREENDIMENTO_LIBERADO
          ) {
            return null;
          }
          if (
            milestone?.details?.reason ===
              STATUS_VA.VA_AGUARDANDO_AGENDAMENTO ||
            milestone?.details?.reason ===
              STATUS_VA.VA_AGUARDADO_AGENDAMENTO_REVISTORIA
          ) {
            return {
              type: "CALL_MIA"
            };
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_VISTORIA ||
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REVISTORIA
          ) {
            if (isTodayVA(milestone?.details?.date)) {
              return ROUTES.VISTORIA_ANTECIPADA_ONBOARDING;
            }
            return null;
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REAGENDAMENTO
          ) {
            return {
              type: "CALL_MIA"
            };
          }
          if (
            milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REAGENDAMENTO
          ) {
            return {
              type: "CALL_MIA"
            };
          }
          if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REPARO) {
            return null;
          }
          if (
            milestone?.details?.reason ===
            STATUS_VA.VA_AGUARDANDO_ANALISE_TECNICA
          ) {
            return null;
          }
          if (milestone?.details?.reason === STATUS_VA.VA_EM_PROCESSAMENTO) {
            return null;
          }
        }
      }
      return MILESTONES_ROUTES[MILESTONES.VISTORIA];
    },
    linkTextSecondary: milestone => {
      if (milestone && milestone.status === MILESTONE_STATUS.RELEASED) {
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_AGENDAMENTO
        ) {
          return null;
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_VISTORIA) {
          return "Reagendar";
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REVISTORIA) {
          return "Reagendar";
        }
      }
      return MILESTONE_STATUS_DATA[milestone.status].text;
    },
    linkSecondary: milestone => {
      if (milestone && milestone.status === MILESTONE_STATUS.RELEASED) {
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_AGENDAMENTO
        ) {
          return null;
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_VISTORIA) {
          return {
            type: "CALL_MIA",
            init: "REAGENDAR COM DATA PARA HOJE"
          };
        }
        if (milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REVISTORIA) {
          return {
            type: "CALL_MIA",
            init: "REAGENDAR COM DATA PARA HOJE"
          };
        }
      }
      return undefined;
    },
    directionButtons: milestone => {
      if (milestone && milestone.status === MILESTONE_STATUS.RELEASED) {
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REAGENDAMENTO
        ) {
          if (isTodayVA(milestone?.details?.date)) {
            return "row";
          }
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_VISTORIA ||
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REVISTORIA
        ) {
          return "row";
        }
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_AGENDAMENTO
        ) {
          return "row";
        }
      }
      return undefined;
    },
    bottomButtons: (milestone, generalData = undefined) => {
      let bookItem = Book;
      let anexoItem = Anexo;

      const typeImage = getThemePropertyValue(
        "milestones.icons.bottomButton.type"
      );

      if (typeImage === "sensia") {
        bookItem = BookSensia;
        anexoItem = AnexoSensia;
      }

      const items = [];

      if (milestone && milestone.status === MILESTONE_STATUS.RELEASED) {
        if (
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_VISTORIA ||
          milestone?.details?.reason ===
            STATUS_VA.VA_AGUARDANDO_REAGENDAMENTO ||
          milestone?.details?.reason ===
            STATUS_VA.VA_AGUARDANDO_ANALISE_TECNICA ||
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REPARO ||
          milestone?.details?.reason ===
            STATUS_VA.VA_AGUARDADO_AGENDAMENTO_REVISTORIA ||
          milestone?.details?.reason === STATUS_VA.VA_AGUARDANDO_REVISTORIA ||
          milestone?.details?.reason === STATUS_VA.VA_CONCLUIDA_APROVADA ||
          milestone?.details?.reason === STATUS_VA.VA_CANCELADA ||
          milestone?.details?.reason === STATUS_VA.VA_BLOQUEADA ||
          milestone?.details?.reason === STATUS_VA.VA_EM_PROCESSAMENTO
        ) {
          items.push({
            image: bookItem,
            name: "Guia da Vistoria",
            url: {
              type: "CALL_SCREEN",
              link: ROUTES.VISTORIA_ANTECIPADA_GUIA
            }
          });
        }
      } else if (milestone && milestone.status === MILESTONE_STATUS.COMPLETE) {
        items.push({
          image: bookItem,
          name: "Guia da Vistoria",
          url: {
            type: "CALL_SCREEN",
            link: ROUTES.VISTORIA_ANTECIPADA_GUIA
          }
        });
      }

      if (milestone) {
        if (
          milestone.status === MILESTONE_STATUS.COMPLETE &&
          generalData?.vaEcDownloadData?.laudoVA?.disponivel
        ) {
          if (items && items[0]) {
            items[0].name = "Guia";
          }
          items.push({
            image: anexoItem,
            name: "Laudo Vistoria",
            url: {
              type: "DOWNLOAD_LAUDO"
            }
          });
        }
      }

      return items;
    }
  },
  {
    MILESTONES_ROUTES,
    id: 3,
    title: getThemePropertyValue(
      "milestones.texts.EC.title.text",
      "Entrega de chaves"
    ),
    titleGtm: getThemePropertyValue(
      "milestones.texts.EC.title.text",
      "Entrega de chaves"
    ),
    // MENSAGEM DO STATUS LÁ ENCIMA
    statusText: (milestone, generalData = undefined) => {
      if (milestone.status === MILESTONE_STATUS.COMING_SOON) {
        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_INTERNA) {
          return "Unidade pendente";
        }

        if (
          generalData?.hasTermPending ||
          (generalData?.hasTermPending &&
            (generalData?.perfil &&
              hasInadimplencia(generalData?.perfil) &&
              milestone?.details?.pendenciaFinanceira))
        ) {
          return "Pendência de aditivo";
        }

        if (
          generalData?.perfil &&
          hasInadimplencia(generalData?.perfil) &&
          milestone?.details?.pendenciaFinanceira
        ) {
          return "Pendência financeira";
        }

        if (
          milestone.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VISTORIA
        ) {
          return "Em breve";
        }

        if (milestone.details?.reason === STATUS_EC.EC_PENDENCIA_BANCARIA) {
          return "Pendência";
        }

        if (
          milestone.details?.reason === STATUS_EC.EC_AGENDADA_CONVENCIONAL &&
          milestone.details?.tipoContrato === "associativo/flex"
        ) {
          return "Pendência";
        }
      }

      if (milestone.status === MILESTONE_STATUS.RELEASED) {
        if (milestone.details?.reason === STATUS_EC.EC_ASSINATURA_PENDENTE) {
          return "Assinatura pendente";
        }

        if (
          milestone.details?.reason ===
            STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_CONVENCIONAL ||
          milestone.details?.reason ===
            STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VIRTUAL
        ) {
          return "Aguardando agendamento";
        }

        if (
          milestone.details?.reason === STATUS_EC.EC_AGENDADA_CONVENCIONAL ||
          milestone.details?.reason === STATUS_EC.EC_AGENDADA_VIRTUAL
        ) {
          return "Entrega agendada";
        }

        if (milestone.details?.reason === STATUS_EC.EC_DIGITAL) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_DIGITAL.status.text",
            "Aguardando chave digital"
          );
        }
      }
      return MILESTONE_STATUS_DATA[milestone.status].text;
    },
    statusTextGtm: (milestone, generalData = undefined) => {
      if (milestone.status === MILESTONE_STATUS.COMING_SOON) {
        if (
          generalData?.hasTermPending &&
          (generalData?.perfil &&
            hasInadimplencia(generalData?.perfil) &&
            milestone?.details?.pendenciaFinanceira)
        ) {
          return "Pendencia de aditivo e pendencia financeira";
        }

        if (
          generalData?.perfil &&
          hasInadimplencia(generalData?.perfil) &&
          milestone?.details?.pendenciaFinanceira
        ) {
          return "Pendência financeira";
        }

        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_BANCARIA) {
          return "Pendência financiamento bancario";
        }

        if (
          milestone?.details?.reason === STATUS_EC.EC_AGENDADA_CONVENCIONAL &&
          milestone?.details?.tipoContrato === "associativo/flex"
        ) {
          return "Pendência alienação fiduciaria";
        }
      }
      return null;
    },
    statusColor: (milestone, generalData = undefined) => {
      if (milestone.status === MILESTONE_STATUS.COMING_SOON) {
        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_INTERNA) {
          return "danger";
        }

        if (
          (generalData?.perfil &&
            hasInadimplencia(generalData?.perfil) &&
            milestone?.details?.pendenciaFinanceira) ||
          generalData?.hasTermPending
        ) {
          return "danger";
        }

        if (
          milestone?.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VISTORIA
        ) {
          return null;
        }

        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_BANCARIA) {
          return "danger";
        }

        if (
          milestone?.details?.reason === STATUS_EC.EC_AGENDADA_CONVENCIONAL &&
          milestone?.details?.tipoContrato === "associativo/flex"
        ) {
          return "danger";
        }
      }
      return null;
    },
    // TEXTO QUE FICA EMBAIXO DO "ENTREGA DE CHAVES"
    text: (milestone, callback, generalData = undefined) => {
      if (milestone.status === MILESTONE_STATUS.COMING_SOON) {
        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_INTERNA) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_PENDENCIA_INTERNA.text.text",
            "No momento, o seu MRV não está apto para esta etapa. Vamos te atualizar por aqui quando o agendamento for liberado, aguarde."
          );
        }

        if (
          generalData?.hasTermPending ||
          (generalData?.hasTermPending &&
            (generalData?.perfil &&
              hasInadimplencia(generalData?.perfil) &&
              milestone?.details?.pendenciaFinanceira))
        ) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_PENDENCIA_ADITIVO.text.text",
            "Assine o aditivo contratual para seguir com o recebimento das chaves. Vamos realizar o seu sonho?"
          );
        }

        if (
          generalData?.perfil &&
          hasInadimplencia(generalData?.perfil) &&
          milestone?.details?.pendenciaFinanceira
        ) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_PENDENCIA_FINANCEIRA.text.text",
            "Fique em dia com a MRV para abrir as portas do seu novo lar."
          );
        }

        if (
          milestone?.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VISTORIA
        ) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_AGUARDANDO_AGENDAMENTO_VISTORIA.text.text",
            "Agende a vistoria. Depois da aprovação dessa etapa, você só precisará assinar o Termo de Recebimento de Chaves para viver o seu sonho."
          );
        }

        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_BANCARIA) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_PENDENCIA_BANCARIA.text.text",
            <>
              Finalize o financiamento do seu MRV para concretizar o seu sonho.
            </>
          );
        }

        if (
          milestone?.details?.reason === STATUS_EC.EC_AGENDADA_CONVENCIONAL &&
          milestone?.details?.tipoContrato === "associativo/flex"
        ) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_PENDENCIA_FIDUCIARIA.text.text",
            <>
              Prepare-se para mudar de vida. Saiba como realizar a alienação
              fiduciária e concretizar seu sonho.
            </>
          );
        }
      }

      if (milestone.status === MILESTONE_STATUS.COMPLETE) {
        return getThemePropertyValue(
          "milestones.texts.EC.complete.text",
          "Você já pegou as suas chaves, agora é hora de viver tudo que um MRV proporciona!"
        );
      }
      if (milestone.status === MILESTONE_STATUS.RELEASED) {
        if (milestone?.details?.reason === STATUS_EC.EC_ASSINATURA_PENDENTE) {
          return <>Assine os termos da entrega.</>;
        }

        if (
          milestone?.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_CONVENCIONAL
        ) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_AGUARDANDO_AGENDAMENTO_CONVENCIONAL.text.text",
            <>
              Está quase na hora! Entraremos em contato por telefone ou WhatsApp
              para agendar a data e o horário.
            </>
          );
        }

        if (
          milestone?.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VIRTUAL
        ) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_AGUARDANDO_AGENDAMENTO_VIRTUAL.text.text",
            <>
              <b>Agende o dia</b> para abrir as portas do seu lar.
            </>
          );
        }

        if (
          milestone?.details?.reason === STATUS_EC.EC_AGENDADA_CONVENCIONAL ||
          milestone?.details?.reason === STATUS_EC.EC_AGENDADA_VIRTUAL
        ) {
          const element = getThemePropertyValue(
            "milestones.texts.EC.EC_AGENDADA_VIRTUAL.text.text"
          );

          if (element && typeof element === "function") {
            return element(milestone, formatDate);
          }

          return (
            <>
              <b>Agendamento realizado!</b> Você receberá as chaves do seu MRV
              em <b>{formatDate(milestone?.details?.date, "DD/MM/YY")}</b>, às{" "}
              <b>{formatDate(milestone?.details?.date, "HH:mm")}h</b>.
            </>
          );
        }

        if (milestone?.details?.reason === STATUS_EC.EC_DIGITAL) {
          return (
            <>
              Enviamos o Termo de Recebimento de Chaves no seu e-mail cadastrado
              em nossa base. Assine-o para receber sua chave digital.
            </>
          );
        }
      }
      return "Prepare-se para mudar de vida. Aguarde o nosso contato.";
    },
    // TEXTO DO BOTÃO VERDE PRINCIPAL
    linkText: (milestone, generalData = undefined) => {
      if (milestone.status === MILESTONE_STATUS.COMING_SOON) {
        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_INTERNA) {
          return null;
        }

        if (
          generalData?.hasTermPending ||
          (generalData?.hasTermPending &&
            (generalData?.perfil &&
              hasInadimplencia(generalData?.perfil) &&
              milestone?.details?.pendenciaFinanceira))
        ) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_PENDENCIA_ADITIVO.button.text",
            "Assinar aditivo"
          );
        }

        if (
          generalData?.perfil &&
          hasInadimplencia(generalData?.perfil) &&
          milestone?.details?.pendenciaFinanceira
        ) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_PENDENCIA_FINANCEIRA.button.text",
            "Jornada Financeira"
          );
        }

        if (
          milestone?.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VISTORIA
        ) {
          return "Agendar com a MIA";
        }

        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_BANCARIA) {
          return "Ler sobre financiamento bancário";
        }

        if (
          milestone?.details?.reason === STATUS_EC.EC_AGENDADA_CONVENCIONAL &&
          milestone?.details?.tipoContrato === "associativo/flex"
        ) {
          return "Ler sobre Alienação Fiduciária";
        }

        return "Saber mais sobre a entrega";
      }

      if (milestone.status === MILESTONE_STATUS.COMPLETE) {
        return null;
      }

      if (milestone.status === MILESTONE_STATUS.RELEASED) {
        if (milestone?.details?.reason === STATUS_EC.EC_ASSINATURA_PENDENTE) {
          return "Iniciar assinatura";
        }
        if (
          milestone?.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VIRTUAL
        ) {
          return "Agendar entrega de chaves";
        }

        if (milestone?.details?.reason === STATUS_EC.EC_AGENDADA_VIRTUAL) {
          return "Consultar data ou reagendar";
        }
      }

      return null;
    },
    // LINK DO BOTÃO VERDE PRINCIPAL
    link: (milestone, generalData = undefined) => {
      if (milestone.status === MILESTONE_STATUS.COMING_SOON) {
        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_INTERNA) {
          return null;
        }

        if (
          generalData?.hasTermPending ||
          (generalData?.hasTermPending &&
            (generalData?.perfil &&
              hasInadimplencia(generalData?.perfil) &&
              milestone?.details?.pendenciaFinanceira))
        ) {
          return getThemePropertyValue(
            "milestones.texts.EC.EC_PENDENCIA_ADITIVO.button.text",
            ROUTES.TERM_ONBOARDING
          );
        }

        if (
          generalData?.perfil &&
          hasInadimplencia(generalData?.perfil) &&
          milestone?.details?.pendenciaFinanceira
        ) {
          const linkValue = getThemePropertyValue(
            "milestones.texts.EC.EC_PENDENCIA_FINANCEIRA.button.link"
          );

          if (linkValue) {
            linkValue.miaUrl = CONST_MAP[linkValue.miaUrl];
            return linkValue;
          }

          return `${meuApeUrls.getFinanceiroUrl()}`;
        }

        if (
          milestone?.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VISTORIA
        ) {
          return {
            type: "CALL_MIA",
            text:
              "Com a MIA, fica fácil achar o melhor dia e horário para\n" +
              "agendar sua vistoria!",
            miaUrl: MIA_AGENDAMENTO_EC
          };
        }

        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_BANCARIA) {
          return `${ROUTES.ENTREGA_DE_CHAVES_GUIA}?tab=DUVIDAS&item=3`;
        }

        if (
          milestone?.details?.reason === STATUS_EC.EC_AGENDADA_CONVENCIONAL &&
          milestone?.details?.tipoContrato === "associativo/flex"
        ) {
          return `${ROUTES.ENTREGA_DE_CHAVES_GUIA}?tab=DUVIDAS&item=5`;
        }

        return MILESTONES_ROUTES[MILESTONES.ENTREGA];
      }

      if (milestone.status === MILESTONE_STATUS.COMPLETE) {
        return null;
      }

      if (milestone.status === MILESTONE_STATUS.RELEASED) {
        if (milestone?.details?.reason === STATUS_EC.EC_ASSINATURA_PENDENTE) {
          return {
            type: "CALL_SIGN",
            link: ROUTES.ENTREGA_DE_CHAVES_LOCATION
          };
        }

        if (
          milestone?.details?.reason ===
            STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VIRTUAL ||
          milestone?.details?.reason === STATUS_EC.EC_AGENDADA_VIRTUAL
        ) {
          return {
            type: "CALL_MIA",
            text:
              "Com a MIA, fica fácil achar o melhor dia e horário para agendar a retirada das suas chaves!",
            callMiaGtm: {
              eventName: "etapa_da_conquista",
              action: "Clique",
              parameters: {
                modal: "Agende na MIA - Entrega de Chaves",
                botao: "Agendar com a MIA"
              }
            },
            miaUrl: MIA_AGENDAMENTO_EC,
            agendarMaisTardeGtm: {
              eventName: "etapa_da_conquista",
              action: "Clique",
              parameters: {
                modal: "Agende na MIA - Entrega de Chaves",
                botao: "Agendar mais tarde"
              }
            }
          };
        }
      }
      return null;
    },
    // TEXTO DO BOTÃO CLARO
    linkTextSecondary: (_milestone, _generalData = undefined) => {
      return null;
    },
    // LINK DO BOTÃO CLARO
    linkSecondary: (_milestone, _generalData = undefined) => {
      return null;
    },
    bottomButtons: (milestone, generalData = undefined) => {
      let itemBook = Book;
      console.log(generalData);
      const typeImage = getThemePropertyValue(
        "milestones.icons.bottomButton.type"
      );

      if (typeImage === "sensia") {
        itemBook = BookSensia;
      }

      const items = [];
      if (milestone.status === MILESTONE_STATUS.COMING_SOON) {
        if (milestone?.details?.reason === STATUS_EC.EC_PENDENCIA_INTERNA) {
          return items;
        }
        if (generalData?.hasTermPending) {
          return items;
        }
        if (
          generalData?.perfil &&
          hasInadimplencia(generalData?.perfil) &&
          milestone?.details?.pendenciaFinanceira
        ) {
          return items;
        }
      }

      if (milestone.status === MILESTONE_STATUS.RELEASED) {
        if (milestone?.details?.reason === STATUS_EC.EC_ASSINATURA_PENDENTE) {
          return items;
        }
      }

      items.push({
        image: itemBook,
        name: "Guia da Entrega de Chaves",
        url: {
          type: "CALL_SCREEN",
          link: ROUTES.ENTREGA_DE_CHAVES_GUIA
        }
      });
      return items;
    },
    extraCard: (milestone, generalData = undefined) => {
      if (milestone.status === MILESTONE_STATUS.COMING_SOON) {
        if (
          generalData?.hasTermPending &&
          generalData?.perfil &&
          hasInadimplencia(generalData?.perfil) &&
          milestone?.details?.pendenciaFinanceira
        ) {
          return {
            statusText: "Pendência financeira",
            statusColor: "danger",
            text: getThemePropertyValue(
              "milestones.texts.EC.EC_PENDENCIA_FINANCEIRA.text.text",
              "Fique em dia com a MRV para abrir as portas do seu novo lar."
            ),
            linkText: getThemePropertyValue(
              "milestones.texts.EC.EC_PENDENCIA_FINANCEIRA.button.text",
              "Jornada Financeira"
            ),
            link: (() => {
              const linkValue = getThemePropertyValue(
                "milestones.texts.EC.EC_PENDENCIA_FINANCEIRA.button.link"
              );
              if (linkValue) {
                linkValue.miaUrl = CONST_MAP[linkValue.miaUrl];
                return linkValue;
              }
              return `${meuApeUrls.getFinanceiroUrl()}`;
            })()
          };
        }
      }
    },
    extraGtmParams: (milestone, _generalData = undefined) => {
      if (milestone.status === MILESTONE_STATUS.COMING_SOON) {
        return {
          tipo: "chave digital"
        };
      }

      if (milestone.status === MILESTONE_STATUS.RELEASED) {
        if (
          milestone?.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_VIRTUAL
        ) {
          return {
            tipo: "chave física - agendamento digital"
          };
        }

        if (milestone?.details?.reason === STATUS_EC.EC_AGENDADA_VIRTUAL) {
          return {
            tipo: "chave física - agendamento digital"
          };
        }

        if (milestone?.details?.reason === STATUS_EC.EC_ASSINATURA_PENDENTE) {
          return {
            tipo: "chave física - agendamento digital"
          };
        }

        if (
          milestone?.details?.reason ===
          STATUS_EC.EC_AGUARDANDO_AGENDAMENTO_CONVENCIONAL
        ) {
          return {
            tipo: "chave física agendamento convencional"
          };
        }

        if (milestone?.details?.reason === STATUS_EC.EC_AGENDADA_CONVENCIONAL) {
          return {
            tipo: "chave física agendamento convencional"
          };
        }

        if (milestone?.details?.reason === STATUS_EC.EC_DIGITAL) {
          return {
            tipo: "chave digital"
          };
        }
      }
      return {};
    }
  }
];
